'use client';

import { useEffect } from 'react';
import { getVisitorId } from '@/app/utils/visitor-tracking';

// Create a global flag to ensure we only track once per page load, regardless of component mounts or remounts
let hasTrackedGlobally = false;

export const WebAnalytics = () => {
  useEffect(() => {
    // Only run once per page load, even if the component mounts multiple times
    if (!hasTrackedGlobally) {
      const trackPageLoadAfterIdle = async () => {
        const { trackPageLoad } = await import('@/app/utils/web-analytics');
        await trackPageLoad();
      };

      // Ensure visitor ID is generated before tracking
      const visitorId = getVisitorId();
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('visitor_id', visitorId);
      }
      // Track page load with preflight
      const browserWindow = window as typeof window & {
        requestIdleCallback?: (callback: IdleRequestCallback) => number;
        cancelIdleCallback?: (handle: number) => void;
      };

      if (browserWindow.requestIdleCallback && browserWindow.cancelIdleCallback) {
        const idleCallbackId = browserWindow.requestIdleCallback(() => {
          trackPageLoadAfterIdle().catch(() => {});
        });

        hasTrackedGlobally = true;
        return () => browserWindow.cancelIdleCallback?.(idleCallbackId);
      }

      const timeoutId = browserWindow.setTimeout(() => {
        trackPageLoadAfterIdle().catch(() => {});
      }, 2000);
      hasTrackedGlobally = true;
      return () => browserWindow.clearTimeout(timeoutId);
    }
  }, []);

  return null;
}; 